import { AppImage, Typography } from '@workspace/ui/common';
import { CustomPortableText } from '@workspace/ui/PortableText';
import { cn, getBackgroundClass, getTextColorClass } from '@workspace/lib';
import type { IconTextColumnsBlockType } from './icon-text-columns-block.types';

export function IconTextColumnsBlock({ block }: { block: IconTextColumnsBlockType }) {
  if (!block) return null;

  const { columns = [], backgroundColor } = block;
  const backgroundClass = getBackgroundClass(backgroundColor);

  return (
    <div className={cn('w-full', backgroundClass)}>
      <div className="porta-container">
        <section className="py-lg px-md md:py-xl md:px-4xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-1 md:gap-2xl">
            {columns.map((column) => {
              const items = Array.isArray(column.listItems) ? column.listItems : [];

              return (
                <div key={column._key} className="flex flex-col gap-xs">
                  {column.heading && (
                    <Typography
                      variant="h3"
                      styleVariant="h5"
                      className={cn('font-bold', getTextColorClass(column.textColor))}
                    >
                      {column.heading}
                    </Typography>
                  )}
                  <ul className="flex flex-col gap-1">
                    {items.map((item, idx) => {
                      const src = item?.listIcon?.selectedUrl || null;
                      const alt = item?.listIcon?.alt || 'icon';

                      return (
                        <li key={item._key ?? `item-${idx}`} className="flex gap-2xs items-start">
                          {src && (
                            <div className="shrink-0 size-4 mt-0.5">
                              <AppImage
                                src={src}
                                alt={alt}
                                width={16}
                                height={16}
                                loading="lazy"
                                className="w-full h-full object-contain"
                              />
                            </div>
                          )}
                          {Array.isArray(item.content) && item.content.length > 0 && (
                            <div className="flex-1 prose prose-gray max-w-none">
                              <CustomPortableText value={item.content} />
                            </div>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              );
            })}
          </div>
        </section>
      </div>
    </div>
  );
}
